import Promises from '@/components/blog/posts/promises/promises';
import Carousel from '@/components/blog/posts/carousel/carousel';
import Posts from './posts';

export default {
    path: '',
    component: Posts,
    children: [
        {
            path: 'promises',
            name: 'promises',
            component: Promises
        },
        {
            path: 'carousel',
            name: 'carousel',
            component: Carousel
        }
    ]
};



// WEBPACK FOOTER //
// ./src/components/blog/posts/posts.routes.js